<template>
    <div>
        <ul class="social-icons">
            <li>
                <a
                    href="https://www.facebook.com/BubblegumBalloons/"
                    target="_blank"
                    class="bg-2025-blue"
                >
                    <FacebookIcon class="fill-white" />
                </a>
            </li>
            <li>
                <a
                    href="http://www.instagram.com/bubblegumballoons"
                    target="_blank"
                    class="bg-2025-orange"
                >
                    <InstagramIcon />
                </a>
            </li>
            <li>
                <a
                    href="http://www.pinterest.com/bubblegumballoons"
                    target="_blank"
                    class="bg-2025-hot-pink"
                >
                    <PinterestIcon />
                </a>
            </li>
            <li>
                <a
                    href="https://twitter.com/3BubblegumGirls"
                    target="_blank"
                    class="bg-2025-lime-green"
                >
                    <TwitterIcon />
                </a>
            </li>
        </ul>

    </div>
</template>

<script>
import FacebookIcon from '~/static/fonts/LineIcons/facebook-filled.svg';
import InstagramIcon from '~/static/fonts/LineIcons/instagram-filled.svg';
import PinterestIcon from '~/static/fonts/LineIcons/pinterest.svg';
import TwitterIcon from '~/static/fonts/LineIcons/twitter-filled.svg';

export default {

    components: {
        FacebookIcon,
        InstagramIcon,
        PinterestIcon,
        TwitterIcon,
    },

};
</script>

<style lang="scss" scoped>
.social-icons {
    @apply flex justify-center md:justify-start text-white mt-3 gap-4;
    a {
        @apply rounded-full flex justify-center items-center transition-property-bg transition-fast;
        width: 3rem;
        height: 3rem;
        &:hover {
            @apply bg-primary;
        }
        svg {
            width: 2rem;
        }
    }
}
</style>
